import React, { useMemo } from 'react'
import { Form } from 'antd-mobile'
import zipObjectDeep from 'lodash/zipObjectDeep'
import styles from './index.scss'
import classnames from 'classnames'
import {
  FieldText,
  FieldPhone,
  FieldSelectSingle,
  FieldCertificate,
  FieldUpload,
  FieldSelectMultiple,
  FieldTextarea,
  FieldDate,
  FieldBookingTime,
  FieldCarNumber,
  FieldInteger
} from './Field'
import { submitServiceData, getServiceData, setUserDefault } from './until'
import Detail from './detail'
import { FormTags } from './tags'

export const verticalColLayout = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 6,
}
const ReadonlyValue = ({
  value,
  prefix,
  style,
}: {
  value?: any
  prefix?: string
  style?: any
}) => (
  <div style={style}>
    {prefix} {value}
  </div>
)

const TemplateUserItem: React.FC<any> = (props) => {
  const { _temRecordIndex, record, getFormValueName } = props
  // 公共
  //  const list: any = {
  //   name: <FieldName {...props} />,
  //   phone: <FieldPhone {...props} />,
  //   age: <FieldInteger {...props} />,
  //   integer: <FieldInteger {...props} />,
  //   text: <FieldName {...props} />,
  //   'custom-text': <FieldName {...props} />, // 自定义文本
  //   'select-single': <FieldSelectSingle {...props} />,
  //   'custom-select-single': <FieldSelectSingle {...props} />, // 自定义单选
  //   'select-multiple': <FieldSelectMultiple {...props} />,
  //   'custom-select-multiple': <FieldSelectMultiple {...props} />, // 自定义多选

  //   idNumber: <FieldCertificate {...props} />,
  //   upload: <FieldUpload {...props} />,
  //   textarea: <FieldTextarea {...props} />,
  //   date: <FieldDate {...props} />, // 日期
  // }
  const createType = (field: Record<string, any>, item?: Record<string, any>) => {
    // console.log('field', field, item, props)
    const _item = {
      ...field,
      customStyles: props?.customStyles,
      isTheme: props?.isTheme,
      form: props?.form,
      disabled: props?.disabled
    }
    switch (field.fieldType) {
      case 'phone':
        return FieldPhone(field, _item)
      case 'integer':
      case 'custom-integer':
      case 'age':
        return FieldInteger(field, _item)
        // return FieldText(field, { ..._item, type: 'number' })
      case 'select-single':
      case 'custom-select-single':
        return FieldSelectSingle(field, _item)
      case 'select-multiple':
      case 'custom-select-multiple':
        return FieldSelectMultiple(field, _item)
      case 'upload':
      case 'custom-upload':
        return FieldUpload(field, _item)
      case 'textarea':
      case 'custom-textarea':
        return FieldTextarea(field, _item)
      case 'date':
      case 'custom-date':
        return FieldDate(field, _item) // 日期
      case 'idNumber': // 身份证
        return FieldCertificate(field, _item)
      case 'carNumber': // 车牌号
        return FieldCarNumber(field, _item)
      case 'timePicker-booking':// 预约时间
        return FieldBookingTime(field, _item)
      default:
        return FieldText(field, _item)
    }
  }

  return (
    <div
      key={`updateFormItem${_temRecordIndex}`}
      className={classnames([
        styles['dp-custom-form--panel'],
        props?.panelClassName,
      ])}
    >
      {record?.shouldShowGroupTitle && record?.groupName && (
        <div
          className={classnames([
            styles['dp-custom-form--panel--title'],
            props?.panelTitleClassName,
          ])}
        >
          <Form.Item name={[...getFormValueName, _temRecordIndex, 'groupName']}>
            <ReadonlyValue />
          </Form.Item>
          {
            record?.tags &&
              <Form.Item name={[...getFormValueName, _temRecordIndex, 'tags']}>
                <FormTags />
              </Form.Item>
          }
        </div>
      )}
      <div
        className={classnames([
          styles['dp-custom-form--container'],
          props?.containerClassName,
        ])}
      >
        {record?.nodeName && record?.parentType !== 'singleton' && (
          <div className={styles['dp-custom-form--panel--node']}>
            <Form.Item
              name={[...getFormValueName, _temRecordIndex, 'nodeName']}
            >
              <ReadonlyValue
                style={{ fontSize: 14, color: `var(--text-color, #202020)` }}
              />
            </Form.Item>
            {
              record?.nodeTags &&
                <Form.Item name={[...getFormValueName, _temRecordIndex, 'nodeTags']}>
                  <FormTags />
                </Form.Item>
            }
          </div>
        )}
        <Form.Item name={[...getFormValueName, _temRecordIndex, 'id']} hidden>
          <ReadonlyValue />
        </Form.Item>
        <Form.Item name={[...getFormValueName, _temRecordIndex, 'type']} hidden>
          <ReadonlyValue />
        </Form.Item>
        <div className={styles['dp-form']} key={_temRecordIndex}>
          {record?.fieldList?.map((item: any, index: number) => {
            const _name = [
              'groupDetailList',
              _temRecordIndex,
              'fieldList',
              index,
            ]
            return (
              <div
                key={record.id + item.fieldCode}
                className={styles['dp-form-record']}
              >
                {createType({ ...item, name: _name })}
                <Form.Item name={[..._name, 'fieldDesc']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'fieldName']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'fieldCode']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'fieldType']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'value']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'ticketName']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'ticketId']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'ticketIndex']} hidden>
                  <ReadonlyValue />
                </Form.Item>
                <Form.Item name={[..._name, 'useNameIndex']} hidden>
                  <ReadonlyValue />
                </Form.Item>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

// 用户模版
const DpCustomAppointmentForm: any = (props: any) => {
  const getFormValueName = props.name
  const { originForm, form } = props
  const getFormValue = form.getFieldValue(getFormValueName) || []

  // 表单
  const genFormTemplate = (num: number = 0) => {
    let _initUserTem: any[] = []
    // 是否多张数量，这里根据那个服务数量做的联动，需要拿商品最新的数据结构
    originForm?.map((parentNode: Record<string, any>, index: number) => {
      // 原始当条数据 -- 初始化
      let parentNodeRecord = {
        id: parentNode.groupId || parentNode.id,
        type: parentNode.type || parentNode.type,
        groupName: parentNode.groupName,
        nodeName: parentNode.nodeName,
        parentType: parentNode?.parentType,
        tags: parentNode?.tags,
        nodeTags: parentNode?.nodeTags,
        fieldList: parentNode?.fieldList?.map((parentNodeFields: Record<string, any>) => ({
          ...parentNodeFields,
          fieldDesc: parentNodeFields.fieldName, // 字段label名 必填,
          fieldCode: parentNodeFields.fieldCode, // 字段code,
          fieldValue: undefined, // 隐藏值,
          value: undefined, // 显示值,
        }))
      } //肯定是数组的
      const changeSetValue = (currentNode: any, _index: number) => {
        return parentNodeRecord?.fieldList?.map((_record: Record<string, any>) => {
          const _currentNode = currentNode?.fieldList?.find((fieldItem: { fieldCode: string }) => fieldItem.fieldCode === _record.fieldCode)
          const _parentNode = parentNode?.fieldList?.find((fieldItem: { fieldCode: string }) => fieldItem.fieldCode === _record.fieldCode)
          // The rules for associating data should be placed externally; otherwise, associate them if they exist.
          const setSpecialRule = props?.getSpecialRule?.(_record, _index, props?.memberInfo)
          const getUserValue = setUserDefault?.(setSpecialRule?.record || _record, setSpecialRule?.memberInfo || props?.memberInfo)
          return ({
            ..._record,
            fieldValue: _currentNode?.fieldValue || _parentNode?.fieldValue || getUserValue?.fieldValue || undefined, // 隐藏值,
            value: _currentNode?.value || _parentNode?.value || getUserValue?.value || undefined, // 隐藏值,
            disabled: getUserValue?.disabled
          })
        })
      }

      if ((parentNodeRecord.parentType ?? parentNode.type) === 'singleton') {
        // 查找组ID已有的数据
        // Find data with existing groupId
        let _findPveValue = getFormValue?.find?.((singletonNode: { id: string }) => String(singletonNode.id) === String(parentNodeRecord.id))
        // 数据结合
        _initUserTem = _initUserTem.concat([{
          groupName: parentNodeRecord.groupName || _findPveValue?.groupName,
          nodeName: parentNodeRecord.nodeName || _findPveValue?.nodeName,
          tags: parentNodeRecord?.tags || _findPveValue?.tags,
          nodeTags: parentNodeRecord?.nodeTags || _findPveValue?.nodeTags,
          id: parentNodeRecord?.id || _findPveValue?.id,
          type: parentNodeRecord?.type || _findPveValue?.type,
          parentType: parentNodeRecord?.parentType ?? _findPveValue?.parentType ?? 'singleton',
          fieldList: changeSetValue?.(_findPveValue, 0) // 查找必填之类的数据
        }])
      } else {
        // 已展开数据（originGroupDetailList）：每条记录对应一张票，直接透传
        let _findPveValue = getFormValue?.find((multipleNode: { id: string }) => String(multipleNode.id) === String(parentNodeRecord.id))
        if (!_findPveValue) {
          const newIdStr = String(parentNodeRecord.id)
          const ticketIdMatch = newIdStr.match(/\[#\]t:([^_]+)_/)
          if (ticketIdMatch) {
            const targetTicketId = ticketIdMatch[1]
            const targetIndex = parseInt(newIdStr.match(/_(\d+)$/)?.[1] || '0') + 1
            const matches = getFormValue?.filter((multipleNode: any) => {
              const nodeTicketId = multipleNode?.fieldList?.[0]?.ticketId
              return String(nodeTicketId) === String(targetTicketId)
            })
            if (matches?.length > 0) {
              _findPveValue = matches.find((entry: any) => entry?.fieldList?.[0]?.useNameIndex === targetIndex)
            }
          }
        }

        // 酒店等场景：model 没有预展开 multiple 组，需要按 fieldsLength 自动复制
        const isRawMultiple = parentNode.type === 'multiple' && !parentNode.parentType
        const expandCount = isRawMultiple ? Math.max(1, num || 1) : 1

        for (let i = 0; i < expandCount; i++) {
          const indexedId = isRawMultiple
            ? `${parentNodeRecord.id}_copy_${i}`
            : parentNodeRecord.id
          const indexedGroupName = isRawMultiple
            ? parentNode?.groupName
              ? `${parentNode.groupName}${i + 1}`
              : undefined
            : parentNode?.groupName
          let _findPveValueForIndex = _findPveValue
          if (isRawMultiple) {
            _findPveValueForIndex =
              getFormValue?.find(
                (multipleNode: { id: string }) =>
                  String(multipleNode.id) === String(indexedId),
              ) || undefined
          }
          _initUserTem = _initUserTem.concat([{
            ...parentNodeRecord,
            id: indexedId,
            groupName: indexedGroupName,
            tags: parentNode?.tags,
            nodeTags: parentNode?.nodeTags,
            parentType: parentNodeRecord.parentType ?? 'multiple',
            fieldList: changeSetValue?.(
              _findPveValueForIndex ?? parentNodeRecord,
              i,
            ),
          }])
        }
      }
      return parentNode
    })
    return _initUserTem
  }

  // 计算每个表单项是否应该显示分组标题
  // singleton始终显示；multiple同一groupName只在第一条显示
  const withGroupTitleFlag = (items: any[]) => {
    const seen = new Set<string>()
    return items.map((item) => {
      if (item?.parentType === 'singleton') {
        return { ...item, shouldShowGroupTitle: !!item?.groupName }
      }
      const key = `${item?.groupName}`
      const shouldShowGroupTitle = !!item?.groupName && !seen.has(key)
      if (shouldShowGroupTitle) seen.add(key)
      return { ...item, shouldShowGroupTitle }
    })
  }

  // 动态表单 -- 根据数量来的
  const dynamicFormUser = useMemo(() => {
    let _initUserTem: any[] = genFormTemplate(props?.fieldsLength)
    _initUserTem = withGroupTitleFlag(_initUserTem)
    form.setFieldsValue(zipObjectDeep([getFormValueName], [_initUserTem]))
    return _initUserTem
  }, [props?.fieldsLength, props?.originForm])

  return (
    <div
      className={classnames(styles['dp-custom-form'], {
        [styles['dp-custom-form--theme']]: props?.isTheme,
      })}
      style={props?.customStyles}
    >
      {dynamicFormUser?.length &&
        (dynamicFormUser || [])?.map((_: any, index: number) => (
          <TemplateUserItem
            getFormValueName={getFormValueName}
            key={index}
            {...props}
            record={_}
            _temRecordIndex={index}
          />
        ))}
    </div>
  )
}

DpCustomAppointmentForm.SubmitServiceData = submitServiceData
DpCustomAppointmentForm.GetServiceData = getServiceData
DpCustomAppointmentForm.Detail = Detail

export default DpCustomAppointmentForm
